import * as stylex from "@stylexjs/stylex";
import { Fragment } from "react";

import { spacing } from "../../../../../../global/stylex/vars.stylex";
import type { BlockProps } from "../../../../refactor";
import { Block } from "../../../../refactor";
import type { ContentMediumProps } from "../ContentMedium";
import { ContentMedium } from "../ContentMedium";

/**
 * Constants
 * styleX requires these to be statically defined in this file
 */
const cssMediaMinWidthTablet = "@media (min-width: 768px)";

const styles = stylex.create({
  actions: {
    marginTop: spacing.m,
  },
  block: {
    display: {
      [cssMediaMinWidthTablet]: "flex",
      default: "none",
    },
  },
  contentMedium: {
    display: {
      [cssMediaMinWidthTablet]: "none",
      default: "flex",
    },
  },
});

export type ContentLargeProps = Pick<
  ContentMediumProps,
  | "asChild"
  | "children"
  | "activeState"
  | "color"
  | "description"
  | "focusState"
  | "hoverState"
  | "imgSrc"
  | "metadata"
  | "metadataInlineIcon"
  | "subscription"
  | "title"
> &
  Pick<BlockProps, "actions" | "color">;

export const ContentLarge = ({
  actions,
  activeState = false,
  asChild,
  children,
  color,
  description,
  focusState = true,
  hoverState = true,
  imgSrc,
  metadata,
  metadataInlineIcon,
  subscription,
  title,
}: ContentLargeProps) => {
  return (
    <Fragment>
      <Block
        actions={actions}
        actionsStyleXArray={[styles.actions]}
        activeState={activeState}
        color={color}
        description={description}
        focusState={focusState}
        hoverState={hoverState}
        imgSrc={imgSrc}
        metadata={metadata}
        metadataInlineIcon={metadataInlineIcon}
        styleXArray={[styles.block]}
        subscription={subscription}
        title={title}
      />
      <ContentMedium
        activeState={activeState}
        asChild={asChild}
        children={children}
        description={description}
        focusState={focusState}
        hoverState={hoverState}
        imgSrc={imgSrc}
        metadata={metadata}
        metadataInlineIcon={metadataInlineIcon}
        styleXArray={[styles.contentMedium]}
        subscription={subscription}
        title={title}
      />
    </Fragment>
  );
};
